import React from "react";
import Hero from "../components/Hero";
import Logo from "../../../../utils/components/Logo";
import Marty from "marty";

let Address = React.createClass({
    getInitialState() { return {}; },
    componentWillMount() {
        this.app.navActions.hideBuyButton();
        this.app.navActions.hideHeader();
        this.app.navActions.hideFooter();
    },
    componentWillUnmount() {
        this.app.navActions.showBuyButton();
        this.app.navActions.showHeader();
        this.app.navActions.showFooter();
    },
    render() {
        return (
            <section className="eo-view address">
                <Hero className="small">
                    <Logo className="eo-logo"/>

                    <h1>Great news — we’re getting ready<br/>to ship your eero system!</h1>
                </Hero>

                <div className="eo-padded-wrapper">
                    <section className="grid-10 eo-section info">
                        <h3>We've closed automatic address capture.</h3>

                        <p>But fear not: to let us know where to ship your eero system, please give our support team a call at<br/>
                            <strong>(877) 659-2347</strong> or <a className="email-link" href="mailto:support@eero.com"><strong>support@eero.com</strong></a>
                        </p>

                    </section>
                </div>
            </section>
        );
    }
});

export default Marty.createContainer(Address);



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/address/Handler.js
 **/